module.exports = __webpack_public_path__ + "src/img/zalando/laptop-and-phone.8d074.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/laptop-and-phone.jpg
// module id = 271
// module chunks = 0